"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ITEM_NBN = void 0;
const index_1 = require("../../constants/index");
const index_2 = require("../../generated-source/api/index");
const site_address_mock_1 = require("./site-address.mock");
exports.MOCK_CART_ITEM_NBN = {
    productDiscounts: [{
            description: 'Monthly Discount',
            discountAmount: '-$15.00',
            frequency: 'Monthly',
            isCouponDiscount: false
        }],
    productContent: {
        displayName: 'Home Basic',
        productConditions: null,
        theme: '#9D15FF',
        productInformationLinkText: 'nbn Key Facts Sheet',
        productInformationLink: '/content/dam/digital/agl/documents/pdf/sample.pdf',
        planSummary: 'Best for 1 or 2 people online at the same time, basic internet use and SD video\r\n',
    },
    sku: '14x13858883',
    cartItemId: '2212',
    additionalData: {
        productCategory: index_2.ProductCategory.Nbn,
        productQualification: {
            serviceOrderType: index_1.ServiceOrderType.New,
            serviceType: 'FTTN',
            siteAddress: site_address_mock_1.MOCK_SITE_ADDRESS,
        },
        productDisplayAttributes: {
            productName: 'Home Basic Test 1',
            infoDoc: '/info_doc_link',
            developmentCharge: 'TRUE',
            price: '80',
            copperPairRecords: [
                {
                    copperPairID: 'CPI300008696589',
                    copperPairStatus: 'N/A',
                    nBNServiceStatus: 'Line Not In Use',
                },
            ],
        },
    },
};
//# sourceMappingURL=cart-item-nbn.mock.js.map